/* Ornamint homepage helpers: hero words, product-row arrows, "Shop the look" (AJAX add), Judge.me reviews slider. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var desktopMq = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  function onMq(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  /* ---------- Decorative loops (sheen, WhatsApp ring, sparkles, scroll cue, reviews marquee) ----------
     CSS gives each a few cycles, then it rests. Here: pause off-screen (.orn-off) and while the tab is hidden
     (html.orn-tab-hidden); restart (.orn-rs toggle) the WhatsApp ring and the reviews marquee each time they come back into
     view, and the hero button sheen on hover / keyboard focus (straight away, without the 1.8 s first-view delay). */
  function restartLoop(el) { el.classList.add('orn-rs'); void el.offsetWidth; el.classList.remove('orn-rs'); }
  document.addEventListener('visibilitychange', function () { document.documentElement.classList.toggle('orn-tab-hidden', document.hidden); });
  if (document.hidden) document.documentElement.classList.add('orn-tab-hidden');
  if ('IntersectionObserver' in window) {
    var loopIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var el = e.target;
        el.classList.toggle('orn-off', !e.isIntersecting);
        if (!e.isIntersecting) { el.__ornLeft = true; return; }
        if (el.__ornLeft && el.matches('.orn-home-wa__btn, .orn-rv__list')) restartLoop(el);   // replay on return
        el.__ornLeft = false;
      });
    }, { rootMargin: '100px 0px' });
    document.querySelectorAll('.orn-home-hero__actions .orn-btn--primary, .orn-home-wa__btn, .orn-home-hero__spk, .orn-home-hero__cue-line, .orn-rv__list').forEach(function (el) { loopIo.observe(el); });
  }
  if (!reduceMotion.matches) document.querySelectorAll('.orn-home-hero--motion .orn-home-hero__actions .orn-btn--primary').forEach(function (btn) {
    var replay = function () {
      var a = btn.getAnimations ? btn.getAnimations({ subtree: true }).filter(function (x) { return x.animationName === 'orn-home-sheen'; })[0] : null;
      if (a && a.playState === 'running') return;   // still in its first-view cycles
      btn.classList.add('orn-nodelay'); restartLoop(btn);
    };
    btn.addEventListener('mouseenter', replay); btn.addEventListener('focus', replay);
  });

  /* ---------- Hero rotating words: one at a time, desktop/mobile sets, paused off-screen; none with reduced motion ---------- */
  function initWords(root) {
    (root || document).querySelectorAll('[data-orn-words]').forEach(function (box) {
      if (box.__ornWords) return;
      box.__ornWords = true;
      var words = [].slice.call(box.children);
      var ms = (parseFloat(box.getAttribute('data-interval')) || 3) * 1000;
      var i = 0, visible = true;
      function pool() {
        var hide = desktopMq.matches ? 'orn-home-hero__word--mobile' : 'orn-home-hero__word--desktop';
        return words.filter(function (w) { return !w.classList.contains(hide); });
      }
      function show(w) {
        words.forEach(function (x) { x.classList.toggle('is-prev', x.classList.contains('is-cur') && x !== w); x.classList.remove('is-cur'); });
        w.classList.add('is-cur');
      }
      function start() {
        var p = pool();
        if (p.length < 2 || reduceMotion.matches) { box.classList.remove('is-js'); return; }
        box.classList.add('is-js');
        i = 0;
        words.forEach(function (x) { x.classList.remove('is-prev'); });
        show(p[0]);
      }
      start();
      onMq(desktopMq, start);
      setInterval(function () {
        if (!visible || document.hidden || !box.classList.contains('is-js')) return;
        var p = pool();
        i = (i + 1) % p.length;
        show(p[i]);
      }, ms);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(box);
      // Theme editor: show the word whose block is selected
      document.addEventListener('shopify:block:select', function (e) {
        if (words.indexOf(e.target) < 0) return;
        box.classList.add('is-js');
        show(e.target);
      });
    });
  }
  /* ---------- Categories, Index layout: hover / focus picks the photo; on touch the first tap picks, the second opens ---------- */
  function initCats(root) {
    (root || document).querySelectorAll('[data-orn-cats="index"]').forEach(function (sec) {
      if (sec.__ornCats) return;
      sec.__ornCats = true;
      var items = [].slice.call(sec.querySelectorAll('[data-orn-cat]'));
      function pick(it) { items.forEach(function (x) { x.classList.toggle('is-active', x === it); }); }
      items.forEach(function (it) {
        it.addEventListener('mouseenter', function () { pick(it); });
        it.addEventListener('focus', function () { pick(it); });
        it.addEventListener('click', function (e) {
          if (it.classList.contains('is-active')) return;
          e.preventDefault();
          e.stopPropagation();
          pick(it);
        });
      });
    });
  }

  /* ---------- Product row filter chips: show the matching products, then re-apply the mobile / desktop counts ---------- */
  function initChips(root) {
    (root || document).querySelectorAll('[data-orn-chips]').forEach(function (box) {
      if (box.__ornChips) return;
      box.__ornChips = true;
      var sec = box.closest('[data-orn-products]');
      var lm = parseInt(sec.getAttribute('data-limit-m'), 10) || 4;
      var ld = parseInt(sec.getAttribute('data-limit-d'), 10) || 8;
      var items = [].slice.call(sec.querySelectorAll('[data-orn-f]'));
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-orn-chip]');
        if (!b) return;
        box.querySelectorAll('[data-orn-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var key = b.getAttribute('data-orn-chip');
        var apply = function () {
          var k = 0;
          items.forEach(function (it) {
            var ok = !key || (' ' + it.getAttribute('data-orn-f') + ' ').indexOf(' ' + key + ' ') > -1;
            it.hidden = !ok;
            if (ok) k++;
            it.classList.toggle('orn-over-m', ok && k > lm);
            it.classList.toggle('orn-over-d', ok && k > ld);
          });
        };
        // Design: a cream panel sweeps across the grid; the products swap while it covers them
        var sweep = sec.querySelector('[data-orn-sweep]');
        if (sweep && sweep.animate && !reduceMotion.matches) {
          sweep.animate([{ transform: 'translateX(-105%)', opacity: 1 }, { transform: 'translateX(0)', opacity: 1, offset: 0.45 }, { transform: 'translateX(0)', opacity: 1, offset: 0.55 }, { transform: 'translateX(105%)', opacity: 1 }], { duration: 1000, easing: 'cubic-bezier(.7,0,.3,1)' });
          setTimeout(apply, 450);
        } else apply();
      });
    });
  }

  /* ---------- Shop by price tabs: links that open their panel (arrow keys move between tabs); without JS they open the filtered collection ---------- */
  function initPriceTabs(root) {
    (root || document).querySelectorAll('[data-orn-price] [role="tablist"]').forEach(function (list) {
      if (list.__ornTabs) return;
      list.__ornTabs = true;
      var tabs = [].slice.call(list.querySelectorAll('[data-orn-tab]'));
      function pick(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          if (t.getAttribute('aria-selected') === 'true') return; // a second click opens the filtered collection
          e.preventDefault();
          e.stopPropagation();
          pick(t);
        });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          pick(tabs[(i + d + tabs.length) % tabs.length], true);
        });
      });
      document.addEventListener('shopify:block:select', function (e) { if (tabs.indexOf(e.target) > -1) pick(e.target); });
    });
  }

  /* ---------- Hero: photo and sparkles follow the mouse a little (mouse/trackpad only, no reduced motion) ---------- */
  function initHeroMouse(root) {
    if (reduceMotion.matches || !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    (root || document).querySelectorAll('.orn-home-hero').forEach(function (hero) {
      if (hero.__ornMouse) return;
      hero.__ornMouse = true;
      var kb = hero.querySelector('[data-orn-kb]'), spk = hero.querySelector('[data-orn-spk]');
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect(), dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5;
        if (kb) kb.style.translate = (-dx * 26).toFixed(1) + 'px ' + (-dy * 18).toFixed(1) + 'px';
        if (spk) spk.style.translate = (dx * 40).toFixed(1) + 'px ' + (dy * 30).toFixed(1) + 'px';
      });
      hero.addEventListener('mouseleave', function () { if (kb) kb.style.translate = ''; if (spk) spk.style.translate = ''; });
    });
  }

  /* ---------- Bun edit steps: one step active for 3.2 s (bar fills), cycling while on screen; click / Enter picks a step ---------- */
  function initSteps(root) {
    if (reduceMotion.matches) return;
    (root || document).querySelectorAll('[data-orn-steps]').forEach(function (list) {
      if (list.__ornSteps) return;
      list.__ornSteps = true;
      var sec = list.closest('.orn-home-bun'), rows = [].slice.call(list.children), cur = 0, timer = null, visible = false;
      if (rows.length < 2) return;
      sec.classList.add('is-cycling');
      function set(i) {
        cur = i;
        rows.forEach(function (r, k) { r.classList.remove('is-on'); r.setAttribute('aria-current', k === i ? 'step' : 'false'); });
        void list.offsetWidth;
        rows[i].classList.add('is-on');
      }
      function restart() { clearInterval(timer); if (visible) timer = setInterval(function () { set((cur + 1) % rows.length); }, 3200); }
      rows.forEach(function (r, k) {
        r.tabIndex = 0;
        r.addEventListener('click', function () { set(k); restart(); });
        r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(k); restart(); } });
      });
      set(0);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) { set(cur); restart(); } else clearInterval(timer); }).observe(list);
      else { visible = true; restart(); }
    });
  }

  initHeroMouse();
  initSteps();
  document.addEventListener('shopify:section:load', function (e) { initHeroMouse(e.target); initSteps(e.target); });

  initWords();
  initCats();
  initChips();
  initPriceTabs();
  document.addEventListener('shopify:section:load', function (e) { initWords(e.target); initCats(e.target); initChips(e.target); initPriceTabs(e.target); });

  /* ---------- Product carousels: prev / next arrows ---------- */
  document.querySelectorAll('[data-orn-products]').forEach(function (sec) {
    var track = sec.querySelector('[data-orn-track]');
    var btns = sec.querySelectorAll('[data-orn-scroll]');
    if (!track || !btns.length) return;
    function update() {
      btns.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-orn-scroll'), 10);
        b.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var item = track.querySelector('li');
        var step = item ? (item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0)) * 2 : track.clientWidth;
        track.scrollBy({ left: step * parseInt(b.getAttribute('data-orn-scroll'), 10), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Carousels (New Arrivals): drag to scroll with the mouse; cards lean slightly with scroll speed (not with reduced motion) ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('.orn-home-products--carousel [data-orn-track]').forEach(function (track) {
      if (track.__ornDrag) return;
      track.__ornDrag = true;
      track.classList.add('is-drag-ready');
      var down = false, moved = false, startX = 0, startLeft = 0;
      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      if (reduceMotion.matches) return;
      var last = track.scrollLeft, lastT = 0, settle = null;
      track.addEventListener('scroll', function () {
        var now = performance.now(), dt = Math.max(16, now - (lastT || now - 16));
        var v = (track.scrollLeft - last) / dt;
        last = track.scrollLeft; lastT = now;
        track.style.setProperty('--tilt', Math.max(-6, Math.min(6, -v * 4)).toFixed(2) + 'deg');
        clearTimeout(settle);
        settle = setTimeout(function () { track.style.setProperty('--tilt', '0deg'); }, 120);
      }, { passive: true });
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });

  /* ---------- "Shop the look": add every item via AJAX, then refresh the header cart count ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-orn-look]');
    if (!btn) return;
    var ids = (btn.getAttribute('data-orn-look') || '').split(',').filter(Boolean);
    if (!ids.length || !window.fetch) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var msg = btn.parentNode.querySelector('[data-orn-look-msg]');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (msg) msg.textContent = btn.getAttribute('data-orn-added') || '';
      })
      .catch(function () { var u = btn.getAttribute('data-orn-fallback'); if (u) window.location.href = u; })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Video testimonials: cover images only until tapped; one video plays at a time; no autoplay ---------- */
  document.querySelectorAll('[data-orn-videos]').forEach(function (vidRoot) {
    vidRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('.orn-vid__play');
      if (!btn) return;
      var frame = btn.closest('[data-orn-vid]');
      var card = frame.closest('.orn-vid');
      var v = frame.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.controls = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.preload = 'auto';
        if (frame.getAttribute('data-poster')) v.poster = frame.getAttribute('data-poster');
        // Adaptive HLS first (used natively by Safari / iOS), then the MP4 for every other browser
        if (frame.getAttribute('data-hls')) { var h = document.createElement('source'); h.src = frame.getAttribute('data-hls'); h.type = 'application/x-mpegURL'; v.appendChild(h); }
        var s = document.createElement('source');
        s.src = frame.getAttribute('data-src');
        if (frame.getAttribute('data-type')) s.type = frame.getAttribute('data-type');
        v.appendChild(s);
        v.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/^Play video:?\s*/, '') || 'Video');
        v.addEventListener('play', function () {
          vidRoot.querySelectorAll('video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        });
        frame.appendChild(v);
      }
      card.classList.add('is-playing');
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      v.focus();
    });
  });

  /* ---------- Reviews: real Judge.me store reviews (same feed as the product page "Store reviews" tab) ---------- */
  var rv = document.querySelector('[data-orn-reviews]');
  if (!rv) return;
  var rvSection = rv.closest('.orn-home-reviews');
  var list = rv.querySelector('[data-orn-rv-list]');
  var nav = rv.querySelector('[data-orn-rv-nav]');
  var allBtns = document.querySelectorAll('[data-orn-rv-all]');
  var shop = rv.getAttribute('data-shop');
  var firstPages = parseInt(rv.getAttribute('data-pages'), 10) || 2;
  var readMore = rv.getAttribute('data-read-more') || 'Read more';
  var showLess = rv.getAttribute('data-show-less') || 'Show less';
  var googleLabel = rv.getAttribute('data-google') || '';
  var loaded = 0, totalPages = 1, seen = {};
  var marqOn = rv.getAttribute('data-marquee') === 'true';
  var speed = parseFloat(rv.getAttribute('data-speed')) || 7;
  var STAR = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
  var dateFmt = window.Intl ? new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : null;

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function card(r) {
    var body = (r.body || '').trim();
    if (!body) return null; // reviews without text are skipped (the heading still shows the live totals)
    var li = el('li', 'orn-rv__card');
    var stars = el('div', 'orn-rv__stars');
    var n = Math.max(0, Math.min(5, Math.round(r.rating || 0)));
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', n + ' out of 5 stars');
    for (var i = 0; i < 5; i++) { var s = el('span', i < n ? 'is-on' : ''); s.innerHTML = STAR; s.setAttribute('data-fx', 'star'); s.style.setProperty('--d', i); stars.appendChild(s); }
    li.appendChild(stars);
    var meta = el('div', 'orn-rv__meta');
    meta.appendChild(el('span', 'orn-rv__name', r.is_anonymous_reviewer ? 'Anonymous' : (r.reviewer_name || '').trim()));
    var d = r.created_at ? new Date(r.created_at) : null;
    if (d && !isNaN(d)) { meta.appendChild(el('span', 'orn-rv__dot', '·')); meta.appendChild(el('span', 'orn-rv__date', dateFmt ? dateFmt.format(d) : d.toLocaleDateString())); }
    li.appendChild(meta);
    if (r.title && r.title.trim()) li.appendChild(el('p', 'orn-rv__title', r.title.trim()));
    li.appendChild(el('p', 'orn-rv__text', body));
    var more = el('button', 'orn-rv__more', readMore);
    more.type = 'button';
    more.hidden = true;
    more.setAttribute('aria-expanded', 'false');
    li.appendChild(more);
    if (googleLabel && (r.transparency_badges || []).indexOf('review_written_in_google_business') > -1) li.appendChild(el('span', 'orn-rv__source', googleLabel));
    return li;
  }
  function markClamped() {
    list.querySelectorAll('.orn-rv__card').forEach(function (c) {
      var t = c.querySelector('.orn-rv__text'), b = c.querySelector('.orn-rv__more');
      if (!t || !b || c.classList.contains('is-open')) return;
      b.hidden = !(t.scrollHeight > t.clientHeight + 1);
    });
  }
  function updateNav() {
    if (rv.classList.contains('is-marquee')) { nav.hidden = true; return; }
    var can = list.scrollWidth > list.clientWidth + 2;
    nav.hidden = !can;
    if (!can) return;
    var b = nav.querySelectorAll('button');
    b[0].disabled = list.scrollLeft <= 2;
    b[1].disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  }
  function page(n) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 5000);
    return fetch('https://cdn.judge.me/reviews/all_reviews_js_based?widget_type=review-widget&page=' + n +
      '&review_type=shop-reviews&sort_by=created_at&sort_dir=desc&widget_theme=standard&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify',
      ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw r; return r.json(); })
      .then(function (j) {
        totalPages = (j.pagination && j.pagination.total_pages) || 1;
        loaded = Math.max(loaded, n);
        (j.reviews || []).forEach(function (r) {
          if (!r.is_shop_review || seen[r.uuid]) return;
          seen[r.uuid] = 1;
          var c = card(r);
          if (c) list.appendChild(c);
        });
      }, function (err) { clearTimeout(timer); throw err; });
  }
  function clearClones() { list.querySelectorAll('[data-orn-clone]').forEach(function (c) { c.parentNode.removeChild(c); }); }
  // Desktop marquee: a second, hidden-from-assistive-tech copy of the cards so the strip loops seamlessly
  function marquee() {
    clearClones();
    var want = marqOn && desktopMq.matches && !reduceMotion.matches && list.children.length > 1;
    rv.classList.toggle('is-marquee', want);
    if (!want) { updateNav(); return; }
    var cards = [].slice.call(list.children);
    cards.forEach(function (c) {
      var k = c.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.setAttribute('data-orn-clone', '');
      k.querySelectorAll('button').forEach(function (b) { b.tabIndex = -1; });
      list.appendChild(k);
    });
    list.style.setProperty('--orn-marq-dur', (cards.length * speed) + 's');
  }
  function after() {
    if (list.children.length) rvSection.hidden = false;
    if (window.ORN && ORN.observe) ORN.observe(list);
    markClamped(); marquee(); updateNav();
    allBtns.forEach(function (b) { b.hidden = loaded >= totalPages || !list.children.length; });
  }
  // Load pages in order until `want` text reviews are shown (or the pages run out)
  function loadMore(want, maxPage) {
    clearClones();
    function step() {
      if (loaded >= totalPages || loaded >= maxPage || list.children.length >= want) return Promise.resolve();
      return page(loaded + 1).then(step);
    }
    return step().then(after, after);
  }

  var startRv = function () { loadMore(firstPages * 5 - 2, firstPages + 3); };
  if ('requestIdleCallback' in window) requestIdleCallback(startRv, { timeout: 2000 }); else setTimeout(startRv, 200);

  allBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      var before = list.children.length;
      loadMore(Infinity, Infinity).then(function () {
        b.disabled = false;
        var first = list.children[before];
        if (first && !rv.classList.contains('is-marquee')) list.scrollTo({ left: first.offsetLeft - list.offsetLeft - (parseFloat(getComputedStyle(list).paddingLeft) || 0), behavior: 'smooth' });
      });
    });
  });
  list.addEventListener('scroll', updateNav, { passive: true });
  window.addEventListener('resize', function () { markClamped(); updateNav(); });
  onMq(desktopMq, function () { if (list.children.length) marquee(); });
  nav.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var c = list.querySelector('.orn-rv__card');
    var step = c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).columnGap) || 0) : list.clientWidth;
    list.scrollBy({ left: step * parseInt(b.getAttribute('data-orn-rv-dir'), 10), behavior: 'smooth' });
  });
  list.addEventListener('click', function (e) {
    var b = e.target.closest('.orn-rv__more');
    if (!b) return;
    var c = b.closest('.orn-rv__card');
    var open = c.classList.toggle('is-open');
    b.textContent = open ? showLess : readMore;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
